/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-21 14:47:46
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-30 16:32:27
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\sectioning.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  useMemo,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
import PitBimwinRadio from '../PitRadio/PitRadio';
import PitBimwinSwitchCheckBox from '../PitBimwinSwitchCheckBox/PitBimwinSwitchCheckBox';
import resethoverImg from '../../assets/images/resethover.png';
import resetImg from '../../assets/images/reset.png';
interface PitModuleSetUpProps {
  // mouseType?: string,
  bimwin?: any;
  // platform: object,
  type?: string;
  changeColor?(color?: any): void;
  // isHover?: boolean
}
const PitModuleSetUp: FC<PitModuleSetUpProps> = ({
  // isHover,
  type = '3D',
  bimwin,
  changeColor,
}) => {
  let [radioType, setradioType] = useState('');
  let [enableLine, setenableLine] = useState(false);
  let [enableHover, setenableHover] = useState(false);
  let [lightValue, setlightValue] = useState(0.5);
  let [speed, setspeed] = useState(1);
  let [shadow, setshadow] = useState('');
  let [colorType, setcolorType] = useState('');
  let [colorIndex, setcolorIndex] = useState<any>(null);
  let [allColor, setallColor] = useState('#ffffff');
  let [is3D] = useState(false);
  let [colorArrList] = useState([
    { color: '#202124' },
    { color: '#d6e0eb' },
    { color: '#409EFF' },
    { color: '#5c5c5c' },
  ]);
  let styleObject = useMemo(() => {
    let count = lightValue * 100;
    return {
      background: `linear-gradient(to right, #57f3ff 0%, #46d0e0 ${count -
        3}%, rgb(153, 153, 153) ${count - 3}%, rgb(153, 153, 153) 100%)`,
    };
  }, [lightValue]);
  let speedStyleObject = useMemo(() => {
    let count = (speed / 16) * 100;
    return {
      background: `linear-gradient(to right, #57f3ff 0%, #46d0e0 ${count -
        3}%, rgb(153, 153, 153) ${count - 3}%, rgb(153, 153, 153) 100%)`,
    };
  }, [speed]);
  let computedColor = useMemo(() => {
    if (allColor === '#ffffff') {
      return {
        background: `linear-gradient(130deg,#ff1a00 7%, #ed940f 13%, #ddd71d 28%, #39c82f 40%, #45ae81 55%, #19d1d1 66%, #1d42db 81%, #b215d8 93%, #e8267a)`,
      };
    }

    return { background: allColor };
  }, [allColor]);
  const change = (value: string) => {
    setradioType(value);
    if (value == '禁用') {
      bimwin && bimwin.setSelectMode('nochoice');
    } else if (value == '单选') {
      bimwin && bimwin.setSelectMode('singlechoice');
    } else if (value == '多选') {
      bimwin && bimwin.setSelectMode('multiplechoice');
    }
  };
  const allColorChange = (e: any) => {
    setallColor(e.target.value);
  };
  const enableLineChange = (value: any) => {
    setenableLine(value);
  };
  const enableHoverChange = (value: any) => {
    setenableHover(value);
  };
  const lightValueChange = (e: any) => {
    setlightValue(e.target.value);
  };
  const speedChange = (e: any) => {
    setspeed(e.target.value);
  };
  const shadowChange = (value: string) => {
    setshadow(value);
    bimwin && bimwin.StartUsingShadow(value === '开启');
  };
  // const ssaoChange = (value: string) => {
  //   bimwin.StartUsingSSAO(value === "开启");
  // }
  const resetBackground = () => {
    setcolorType('');
    setallColor('#ffffff');
  };
  const handleSkyBoxClick = () => {
    setcolorType('skybox');
    bimwin && bimwin.setDefaultSkyBox();
    setallColor('#ffffff');
  };
  const handelColorSelect = (index: number) => {
    setcolorIndex(index);
    setcolorType('defaultColorList');
    setallColor('#ffffff');
    changeColor && changeColor(colorArrList[index].color);
  };
  const colorArrListNode = colorArrList.map((item: any, index: number) => {
    return (
      <div
        key={index}
        className={`pit-color-item pointer ${
          index === colorIndex && colorType === 'defaultColorList'
            ? 'pit-color-select'
            : ''
        }`}
        onClick={() => handelColorSelect(index)}
      >
        <span
          className="pit-color-node"
          style={{ background: item.color }}
        ></span>
      </div>
    );
  });
  return (
    <div>
      <div className="pit-panel-container pit-scroll-bar">
        <form className="pit-setting">
          <ul className="pit-setting-tab-default" style={{ display: 'block' }}>
            <li className="pit-setting-li">
              <span className="pit-setting-name">点选模式：</span>
              <div
                className="pit-setting-value pit-setting-range"
                id="exposure"
              >
                <div className="pit-range">
                  <div className="radioBox">
                    <PitBimwinRadio
                      light
                      value={radioType}
                      onChange={() => change('禁用')}
                      label="禁用"
                    ></PitBimwinRadio>
                    <PitBimwinRadio
                      light
                      value={radioType}
                      onChange={() => change('单选')}
                      label="单选"
                    ></PitBimwinRadio>
                    <PitBimwinRadio
                      light
                      value={radioType}
                      onChange={() => change('多选')}
                      label="多选"
                    ></PitBimwinRadio>
                  </div>
                </div>
              </div>
            </li>
            <li
              className="pit-setting-li"
              style={{ display: type === '3D' ? '' : 'none' }}
            >
              <ul style={{ listStyle: 'none' }}>
                <li className="flex">
                  <span
                    className="pit-setting-name"
                    style={{ position: 'relative' }}
                  >
                    是否显示线框：
                  </span>
                  <PitBimwinSwitchCheckBox
                    value={enableLine}
                    onChange={enableLineChange}
                  />
                </li>
              </ul>
            </li>
            <li
              className="pit-setting-li"
              style={{ display: type === '3D' ? '' : 'none' }}
            >
              <ul style={{ listStyle: 'none' }}>
                <li className="flex">
                  <span
                    className="pit-setting-name"
                    style={{ position: 'relative' }}
                  >
                    鼠标悬停：
                  </span>
                  <PitBimwinSwitchCheckBox
                    value={enableHover}
                    onChange={enableHoverChange}
                  />
                </li>
              </ul>
            </li>
            <li
              className="pit-setting-li"
              style={{ display: type === '3D' ? '' : 'none' }}
            >
              <span className="pit-setting-name">亮度：</span>
              <div
                className="pit-setting-value pit-setting-range"
                id="exposure"
              >
                <div className="pit-range">
                  <input
                    className="pit-input-range"
                    type="range"
                    step="0.02"
                    min="0.1"
                    max="1.0"
                    value={lightValue}
                    onChange={lightValueChange}
                    style={{
                      marginTop: '18px',
                      cursor: 'pointer',
                      ...styleObject,
                    }}
                  />
                  <span className="pit-range-min">0.1</span>
                  <span className="pit-range-cur">{lightValue}</span>
                  <span className="pit-range-max">1.0</span>
                  <span className="pit-range-progress"></span>
                </div>
              </div>
            </li>
            <li
              className="pit-setting-li"
              style={{ display: type === '3D' ? '' : 'none' }}
            >
              <span className="pit-setting-name">微调鼠标速度：</span>
              <div className="pit-setting-value pit-setting-range" id="speed">
                <div className="pit-range">
                  <input
                    className="pit-input-range"
                    type="range"
                    step="1"
                    min="1"
                    max="16"
                    value={speed}
                    onChange={speedChange}
                    style={{
                      marginTop: '18px',
                      cursor: 'pointer',
                      ...speedStyleObject,
                    }}
                  />
                  <span className="pit-range-min">1</span>
                  <span className="pit-range-cur">{speed}</span>
                  <span className="pit-range-max">16</span>
                  <span className="pit-range-progress"></span>
                </div>
              </div>
            </li>
            <li
              className="pit-setting-li"
              style={{ display: type === '3D' ? '' : 'none' }}
            >
              <span className="pit-setting-name">平行光投影：</span>
              <div className="pit-setting-value pit-setting-range">
                <div className="pit-range">
                  <div className="radioBox">
                    <PitBimwinRadio
                      value={shadow}
                      light
                      onChange={() => shadowChange('开启')}
                      label="开启"
                    ></PitBimwinRadio>
                    <PitBimwinRadio
                      light
                      value={shadow}
                      onChange={() => shadowChange('禁用')}
                      label="禁用"
                    ></PitBimwinRadio>
                  </div>
                </div>
              </div>
            </li>
            <li className="pit-setting-li">
              <span className="pit-setting-name">背景色：</span>
              <div className="pit-color">
                {colorArrListNode}
                {is3D ? (
                  <div
                    className={`pit-color-item ${
                      colorType === 'skybox' ? 'pit-color-select' : ''
                    }`}
                    onClick={handleSkyBoxClick}
                    title="天空盒"
                  >
                    <div className="pit-color-node">
                      <div className="pit-color-skybox"></div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                <div
                  className={`pit-color-item ${
                    colorType === 'allColor' ? 'pit-color-select' : ''
                  }`}
                >
                  <div className="pit-color-node" title="自定义背景色">
                    <div className="all-color" style={computedColor}>
                      <input
                        type="color"
                        value={allColor}
                        onChange={allColorChange}
                        // style={{ visible: false }}
                      />
                    </div>
                  </div>
                </div>
                <span className="pit-color-item">
                  <span
                    className="resetImg"
                    onClick={resetBackground}
                    title="重置背景"
                  >
                    <img className="imgHover" src={resethoverImg} alt="" />
                    <img className="img" src={resetImg} alt="" />
                  </span>
                </span>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </div>
  );
};
export default PitModuleSetUp;
